import { isWeb } from './platform';

// Public R2 bucket behind Cloudflare ($0 egress). These are the same bytes
// the desktop download gates fetch into the persistent disk cache (see
// fetchCardImage in electron/server.js): regular card art, custom tokens
// and baked foil maps all live under the `cards/` prefix.
const CARD_CDN_BASE = 'https://cards.valkenhall.com/cards';

// Single URL builder for card art. Desktop keeps root-relative
// `/sorcery-images/` paths served by the Electron server's disk cache;
// the web build goes straight to the CDN.
//
// The `-rf` (rainbow foil) alias mirrors handleSorceryImage in
// electron/server.js: rainbow has no upstream asset and falls back to the
// standard art. The desktop server additionally retries the unaliased slug
// for foil-only catalog entries; a static CDN can't, so those rare slugs
// fall through to the card's placeholder frame on web.
// Cache-splitter for crossOrigin texture fetches on web. A card art URL
// is first fetched by a plain <img> (no Origin header), and the CDN's
// response then carries neither access-control-allow-origin nor
// vary: Origin. Safari reuses that cached response for a later
// crossOrigin='anonymous' WebGL texture fetch of the same URL and fails
// the CORS check, so foil/board textures never load while the plain
// <img>s look fine. A distinct query param gives texture fetches their
// own cache entry, always requested WITH an Origin header (R2 then
// replies with ACAO + Vary). Desktop art URLs are same-origin local
// server paths, which need no CORS and are returned untouched.
export function corsTextureUrl(url) {
  if (!isWeb() || !url || !/^https:\/\//i.test(url)) return url;
  return url + (url.includes('?') ? '&' : '?') + 'tex=1';
}

export function sorceryImageUrl(slug, origin = '') {
  if (isWeb()) {
    const resolved = slug.replace(/-rf$/i, '-s');
    return `${CARD_CDN_BASE}/${resolved}.webp`;
  }
  return `${origin}/sorcery-images/${slug}.webp`;
}
